import Request from 'request';

export default {
    listTopicField: async () => {
        try {
            const res = await Request.get('/topic/topic_fieldlet_nodes', {});

            return {
                data: res.data,
                count: res.totalCount
            };
        } catch (err) {
            console.error(err);
        }
    }
};
